import type { BaseKeyFunction } from "../../../../lib";

export type KeyCommunitiesChildrenProps = {
  id: number;
};

export const keyCommunitiesChildren: BaseKeyFunction<
  KeyCommunitiesChildrenProps
> = ({ id }) => ["communities-children", id.toString()];
